import apiClient from '../api/apiClient';
import ContactService from '../contact/ContactService';
import SecureSessionService from '../session/SecureSessionService';
import { ContactDetails,InitiateOtpRequest, InitiateOtpResponse, VerifyOtpRequest, VerifyOtpResponse } from '../../types/mfa';

class MfaService {
  /**
   * Get contact details (phones and emails) for MFA
   */
  static async getContactDetails(sessionId: string): Promise<ContactDetails> {
    try {
      const session = SecureSessionService.getStoredSession();
      const username = session?.userId;

      if (!username) {
        throw new Error('Username not found in session');
      }

      const contactDetails = await ContactService.getMemberRegistrationDetails(username, sessionId);
      
      if (!contactDetails) {
        // Return empty arrays if no contacts (will trigger "No Contact" page)
        return { phones: [], emails: [] };
      }

      return contactDetails;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Initiate OTP for MFA verification
   */
  static async initiateOtp(request: InitiateOtpRequest, sessionId: string): Promise<InitiateOtpResponse> {
    try {
      const response = await apiClient.post<InitiateOtpResponse>(
        `okta/initiateOtp?sessionId=${sessionId}`,
        request
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Verify OTP for MFA verification
   */
  static async verifyOtp(request: VerifyOtpRequest, sessionId: string): Promise<VerifyOtpResponse> {
    try {
      const response = await apiClient.post<VerifyOtpResponse>(
        `okta/verifyOtp?sessionId=${sessionId}`,
        request
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default MfaService;
